/* eslint-disable */
import Lesson from "@/views/lesson/Lesson.vue";
import LessonDetail from "@/views/activity/List.vue";
import TypeActivity from "@/views/activity/TypeActivity.vue";

export default [
  {
    path: "/mis-clases",
    name: "Lesson",
    component: Lesson,
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
  {
    path: "/mis-clases/clase/:id",
    name: "Lesson Detail",
    props: true,
    component: LessonDetail,
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
  {
    path: "/mis-clases/clase/:id/:type",
    name: "Activity Detail",
    props: true,
    component: TypeActivity,
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
  {
    path: "/mis-clases-por-asignatura",
    name: "Lesson by subject",
    component: Lesson,
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
  {
    path: "/mi-progreso",
    name: "My progress",
    component: Lesson,
    meta:{
      requiresAuth: true,
      roles: ['AulaVirtual']
    },
  },
];
